import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Feedback {
  name: string;
  api_token: string;
}

export interface FeedbackListInfor {
  errors: unknown;
  feedback: Feedback;
  isAuthenticated: boolean;
}

@Module
export default class FeedbackModule
  extends VuexModule
  implements FeedbackListInfor
{
  errors = {};
  feedback = {} as Feedback;
  isAuthenticated = !!JwtService.getToken();

  get Feedbacks() {
    return this.feedbackListData;
  }

  @Mutation
  [Mutations.FEEDBACKS_LIST_DATA](Feedbacks) {
    this.feedbackListData = Feedbacks;
  }

  @Action
  [Actions.FEEDBACKS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("feedback", payload)
        .then((data) => {
          this.context.commit(Mutations.FEEDBACKS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.FEEDBACK_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/feedback", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.FEEDBACKS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.FEEDBACK_UPDATE_STATUS](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/feedback/${payload.id}/update-status`, payload)
        .then((data) => {
          this.context.commit(Mutations.FEEDBACKS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
